import { render, staticRenderFns } from "./masterAccount.vue?vue&type=template&id=4b3cfee8"
import script from "./masterAccount.vue?vue&type=script&lang=js"
export * from "./masterAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports